import { graphql, useStaticQuery } from 'gatsby';
import { getImage, IGatsbyImageData, ImageDataLike } from 'gatsby-plugin-image';
import { logError } from 'utils/helpers';

import { LineItem } from '../types';

const useCartImage = (variant: LineItem): IGatsbyImageData | undefined => {
  const result = useStaticQuery<{
    allContentfulProduct: {
      nodes: Array<{ slug?: string; boxImage: ImageDataLike }>;
    };
  }>(graphql`
    query {
      allContentfulProduct {
        nodes {
          slug
          boxImage {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
    }
  `);

  const product = result.allContentfulProduct.nodes.find(
    (node) => node.slug === variant.product_sku,
  );

  if (product) {
    return getImage(product.boxImage);
  } else {
    logError('could not match product to variant to get boxImage', {
      component: 'hooks/useCartImage',
      method: 'useCartImage',
      product,
      variant,
    });
  }
};

export default useCartImage;
